import { Link } from "react-router-dom";
import { ArrowRight, Gauge, ShieldCheck, Users } from "lucide-react";
import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import Marquee from "../components/Marquee";
import { Reveal, MaskLines } from "../components/Motion";

const VALUES = [
  [ShieldCheck, "Purity first", "We supply AdBlue meant to protect your SCR system and keep emissions in check."],
  [Gauge, "Reliable supply", "Consistent availability so your vehicles never wait for fluids."],
  [Users, "Partnership", "We grow together with our customers, dealers and franchise partners."],
];

export default function About() {
  return (
    <>
      <Seo title="About Us" description="MHM SUPER ADBLUE is a Haldia, West Bengal based supplier of AdBlue (DEF) and lubricating oils for commercial vehicles and transport businesses." />
      <PageHeader testid="about-header" eyebrow="About us" lines={["From Haldia,", { text: "for India's roads.", cls: "text-brand" }]} image="/img/real/shop-1.jpg" />
      <section className="bg-white py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-12 lg:px-8">
          <div className="lg:col-span-6">
            <p className="eyebrow text-brand">Our story</p>
            <h2 className="mt-4 font-display text-5xl md:text-6xl font-extrabold uppercase leading-[0.92] text-navy">
              <MaskLines inView lines={["Fluids that keep", "fleets moving."]} />
            </h2>
            <div className="mt-8 space-y-5 text-slate-600 leading-relaxed">
              <p>MHM SUPER ADBLUE is based in Haldia, Purba Medinipur, West Bengal. We supply AdBlue (Diesel Exhaust Fluid) and lubricating oils for commercial vehicles, trucks and transport businesses.</p>
              <p>Alongside AdBlue, we offer lubricant categories for Tata, Gulf, Eicher and BharatBenz vehicles — so operators can source their essential fluids from one trusted supplier.</p>
              <p>Our goal is to build a scalable AdBlue supply and distribution brand across India, working hand in hand with dealers and franchise partners.</p>
            </div>
            <Link to="/contact" data-testid="about-contact-button" className="group mt-10 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-4 font-semibold text-white transition-colors hover:bg-brand">
              Talk to us <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
          <Reveal delay={0.1} className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-4">
              <div className="clip-arch col-span-1 row-span-2 overflow-hidden bg-navy aspect-[3/5]">
                <img src="/img/real/shop-1.jpg" alt="MHM SUPER ADBLUE Tata D.E.F shop" className="h-full w-full object-cover" />
              </div>
              <div className="overflow-hidden rounded-[22px] spotlight aspect-square">
                <img src="/img/real/tata-bucket.jpg" alt="Tata Motors D.E.F 20 L bucket" className="h-full w-full object-contain p-3 mix-blend-multiply" />
              </div>
              <div className="overflow-hidden rounded-[22px] spotlight aspect-square">
                <img src="/img/real/gulf-bucket.jpg" alt="Gulf AdBlue 20 L bucket" className="h-full w-full object-contain p-3 mix-blend-multiply" />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
      <Marquee />
      <section className="bg-[var(--paper)] py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <p className="eyebrow text-brand">What we stand for</p>
            <h2 className="mt-4 font-display text-5xl md:text-6xl font-extrabold uppercase leading-[0.92] text-navy">Our values</h2>
          </Reveal>
          <div className="mt-12 grid gap-5 md:grid-cols-3">
            {VALUES.map(([Icon, t, d], i) => (
              <Reveal key={t} delay={i * 0.08}>
                <div className="h-full rounded-[22px] border border-navy/10 bg-white p-8">
                  <span className="font-mono text-sm text-brand">0{i + 1}</span>
                  <Icon className="mt-6 h-9 w-9 text-navy" />
                  <h3 className="mt-5 font-display text-3xl font-bold uppercase text-navy">{t}</h3>
                  <p className="mt-2 text-slate-600">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
